import { useEffect, useState } from "react";
import { fetchPublicVehicleTypes, fetchPublicVehicleStandards } from "../services/api";
import {
  DEFAULT_VEHICLE_TYPE,
  FALLBACK_VEHICLE_TYPES,
  FALLBACK_VEHICLE_STANDARDS,
} from "../constants/vehicleCatalog";
import { t } from "../i18n";

/**
 * Loads public vehicle type / standard lists for merchant route flows.
 */
export function usePublicVehicleCatalog() {
  const [vehicleTypes, setVehicleTypes] = useState(FALLBACK_VEHICLE_TYPES);
  const [vehicleStandards, setVehicleStandards] = useState(FALLBACK_VEHICLE_STANDARDS);
  const [catalogError, setCatalogError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setCatalogError("");
      try {
        const [types, stds] = await Promise.all([
          fetchPublicVehicleTypes(),
          fetchPublicVehicleStandards(),
        ]);
        if (cancelled) return;
        setVehicleTypes(types.length > 0 ? types : FALLBACK_VEHICLE_TYPES);
        setVehicleStandards(stds.length > 0 ? stds : FALLBACK_VEHICLE_STANDARDS);
      } catch (e) {
        if (!cancelled) {
          setVehicleTypes(FALLBACK_VEHICLE_TYPES);
          setVehicleStandards(FALLBACK_VEHICLE_STANDARDS);
          setCatalogError(t("vehicle.offline_lists"));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { vehicleTypes, vehicleStandards, catalogError, DEFAULT_VEHICLE_TYPE };
}
